import React from "react";
import ProgramCard from "./ProgramCard";
import RecProgramCard from "./RecProgramCard";
import useOnScreen from "../../hooks/useOnScreen";

const Promosi = () => {
  const [ref, isVisible] = useOnScreen({ threshold: 0.1 });

  return (
    <section id="promo" className="st-surface-program overflow-x-clip px-4 py-14 sm:py-16" ref={ref}>
      <div className="mx-auto w-full max-w-6xl">
        <div className={`text-center ${isVisible ? "animate__animated animate__fadeInUp" : ""}`}>
          <p className="st-font-body st-program-pill mx-auto">
            -- PROGRAM UNGGULAN --
          </p>
          <h2 className="st-font-display st-text-cream-heading mt-8 text-[42px] leading-[1.08] sm:text-[52px] lg:text-[64px]">
            <span className="italic">Pilih Program yang</span> <span className="font-bold">Sesuai</span>
            <br />
            <span className="italic">dengan</span> <span className="font-bold">Target Skormu</span>
          </h2>

          <p className="st-font-body st-text-program-soft mx-auto mt-6 max-w-3xl text-[20px] leading-[1.35] sm:text-[24px]">
            Dirancang untuk membantu kamu belajar lebih
            <br className="hidden sm:block" />
            <span className="font-bold text-[#FFF7EB]"> terarah dan efektif</span>
          </p>
        </div>

        <div className={`mt-12 grid gap-6 lg:grid-cols-2 ${isVisible ? "animate__animated animate__fadeInUp" : ""}`}>
          <RecProgramCard
            title="Private Class"
            score="7.0"
            oldPrice="Rp 2.000.000"
            price="Rp 1.390.800"
            description="Bimbingan eksklusif 1-on-1 dengan jadwal yang sepenuhnya fleksibel"
            features={[
              "Garansi Skor 7.0",
              "Jadwal Fleksibel (Bisa atur waktu belajar sendiri)",
              "Personalized Feedback langsung dari tutor expert",
              "Gratis Simulasi IELTS & Prediction Test berkala",
              "Modul & E-Certificate resmi dari Scholars Today",
            ]}
            ctaLabel="DAFTAR KELAS PRIVATE ->"
            theme="private"
          />

          <ProgramCard
            title="Intensive Class"
            score="6.5"
            oldPrice="Rp 2.000.000"
            price="Rp 497.000"
            description="Belajar intensif dalam grup interaktif dengan materi super lengkap"
            features={[
              "Target Skor 6.5+ dengan kurikulum standar internasional",
              "Live Class intensif via Zoom bersama tutor berpengalaman",
              "Diskusi Grup Aktif untuk melatih kepercayaan diri",
              "Akses Rekaman Kelas yang bisa dipelajari ulang kapan saja",
              "Materi 4 Pilar IELTS (Reading, Writing, Listening, Speaking)",
            ]}
            ctaLabel="DAFTAR KELAS INTENSIF ->"
            theme="intensive"
          />
        </div>
      </div>
    </section>
  );
};

export default Promosi;